import { Component, signal, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

export interface MenuItem {
  label: string;
  icon: string;
  route: string;
}

@Component({
  selector: 'app-sous-header',
  standalone: false,
  templateUrl: './sous-header.component.html',
  styleUrls: ['./sous-header.component.scss'],
})
export class SousHeaderComponent implements OnInit {
  currentRoute = signal('');

  menuItems = signal<MenuItem[]>([
    {
      label: 'Fiche club',
      icon: 'info',
      route: '/club',
    },
    {
      label: 'Liste des joueurs',
      icon: 'people',
      route: '/Joueurs',
    },
    {
      label: 'Liste des dirigeants',
      icon: 'admin_panel_settings',
      route: '/Dirigeants',
    },
  ]);

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.currentRoute.set(this.router.url);
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.currentRoute.set(event.urlAfterRedirects);
      });
  }

  navigateTo(item: MenuItem): void {
    this.router.navigate([item.route]);
  }

  isActive(route: string): boolean {
    const current = this.currentRoute();
    return current === route || current.startsWith(route + '/');
  }
}
